import React, { useEffect, useState } from "react";
import { History, Sparkles } from "lucide-react";
import api from "../services/api";
import ProductCard from "./ProductCard";

const KEY = "kts_recent";
export const recordView = (id) => {
  try {
    const prev = JSON.parse(localStorage.getItem(KEY) || "[]").filter((x) => x !== id);
    localStorage.setItem(KEY, JSON.stringify([id, ...prev].slice(0, 12)));
  } catch { /* noop */ }
};
const readRecent = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

const Section = ({ icon: Icon, kicker, title, products, testid }) => (
  <section className="mt-16" data-testid={testid}>
    <div className="mb-6">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF3B3B] font-bold mb-2 flex items-center gap-2"><Icon size={14} /> {kicker}</div>
      <h2 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-2xl md:text-3xl">{title}</h2>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-5">{products.map((p) => <ProductCard key={p.id} product={p} />)}</div>
  </section>
);

export const RecentlyViewed = ({ exclude, limit = 4 }) => {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const ids = readRecent().filter((x) => x !== exclude).slice(0, limit);
    if (ids.length === 0) { setProducts([]); return; }
    api.get(`/products-batch?ids=${ids.join(",")}`).then(({ data }) => setProducts(data)).catch(() => setProducts([]));
  }, [exclude, limit]);
  if (products.length === 0) return null;
  return <Section icon={History} kicker="Reprenez où vous en étiez" title="Vus récemment" products={products} testid="recently-viewed" />;
};

export const AlsoBought = ({ productId, limit = 4, compact = false }) => {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    if (!productId) return;
    api.get(`/products/${productId}/also-bought?limit=${limit}`).then(({ data }) => setProducts(data.products)).catch(() => setProducts([]));
  }, [productId, limit]);
  if (products.length === 0) return null;
  if (compact) {
    return (
      <div className="mt-6" data-testid="also-bought-compact">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF3B3B] font-bold mb-3 flex items-center gap-2"><Sparkles size={14} /> Souvent achetés ensemble</div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{products.map((p) => <ProductCard key={p.id} product={p} />)}</div>
      </div>
    );
  }
  return <Section icon={Sparkles} kicker="Nos clients complètent avec" title="Souvent achetés ensemble" products={products} testid="also-bought" />;
};
